import React, { Component } from 'react';
import FormModal from 'components/shared/modal/FormModal';
import { connect } from 'react-redux';
import {
  createReceipt,
  editReceipt,
  setShowAddMaterialsModal,
} from 'components/admin/work-orders/details/receipts/store/actions';
import {
  receiptToEditSelector,
  showAddMaterialsModalSelector,
} from 'components/admin/work-orders/details/receipts/store/selectors';
import AddMaterialsForm from 'components/admin/work-orders/details/receipts/AddMaterialsForm';
import numeral from 'numeral';
import { getTasks } from 'selectors/admin/work-orders/work-orders';

class AddMaterialsModal extends Component {
  handleClose = () => {
    this.props.dispatch(setShowAddMaterialsModal(false));
  };

  handleOnSubmit = (values) => {
    const { receiptToEdit } = this.props;
    const edit = receiptToEdit !== null;
    if (edit) {
      let imageIdToDelete = null;
      if (receiptToEdit.image !== null && values.image === '') {
        imageIdToDelete = receiptToEdit.image.id;
      }
      let documentIdToDelete = null;
      if (receiptToEdit.document !== null && values.document === '') {
        documentIdToDelete = receiptToEdit.document.id;
      }
      this.props.dispatch(
        editReceipt(
          receiptToEdit.id,
          values,
          imageIdToDelete,
          documentIdToDelete
        )
      );
    } else {
      this.props.dispatch(createReceipt(values.taskId, values));
    }
  };

  render() {
    const { receiptToEdit, tasks } = this.props;
    let initialValues = null;
    if (receiptToEdit !== null) {
      initialValues = {
        taskId: tasks.find((task) => task.number === receiptToEdit.task_number)
          .id,
        cost: numeral(receiptToEdit.cost).value().toString(),
        description: receiptToEdit.description,
      };
      if (receiptToEdit.image !== null) {
        initialValues.image = receiptToEdit.image.image;
      }
      if (receiptToEdit.document !== null) {
        initialValues.document = receiptToEdit.document.document;
      }
    }
    const edit = receiptToEdit !== null;
    return (
      <div>
        <FormModal
          className="add-materials-modal"
          show={this.props.show}
          title={edit ? 'Edit Materials' : 'Add Materials'}
          onClose={this.handleClose}
        >
          <AddMaterialsForm
            initialValues={initialValues}
            tasks={this.props.tasks}
            onSubmit={this.handleOnSubmit}
          />
        </FormModal>
      </div>
    );
  }
}

export default connect((state) => {
  return {
    receiptToEdit: receiptToEditSelector(state),
    show: showAddMaterialsModalSelector(state),
    tasks: getTasks(state),
  };
})(AddMaterialsModal);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/receipts/AddMaterialsModal.js